<ion-item *ngIf="errorMessage != null" lines="none">
    <ion-text color="danger" class="form-error">
      {{ errorMessage }}
    </ion-text>
  </ion-item>
